<div class="task-comments">
  <div class="task-comments__scrollable">
    <ng-content></ng-content>

    <h3 class="task-comments__title">COMENTÁRIOS</h3>

    <div class="task-comments__list">
      @for (comment of comments; track comment.id) {
        <div class="task-comments__bubble" [class.task-comments__bubble--self]="!comment.isCurrentUser">
          <div class="task-comments__header">
            <span class="task-comments__author">
              {{ comment.isCurrentUser ? "USUÁRIO" : "SUPORTE" }}:
              {{
                comment.user
                  ? (comment.user.name + " " + comment.user.last_name | uppercase)
                  : (comment.commenter | uppercase)
              }}
            </span>
            <span class="task-comments__date">
              {{ comment.created_at | date: "dd/MM/yyyy - HH:mm" }}
            </span>
          </div>
          <p class="task-comments__content">{{ comment.body }}</p>
          @if (comment.documents.length) {
            <div class="task-comments__attachments">
              <strong>ANEXOS:</strong>
              @for (doc of comment.documents; track doc.id) {
                <a class="task-comments__attachment-item" [href]="doc.url" target="_blank">
                  <i class="pi pi-paperclip"></i> {{ doc.title || doc.url.split("/").pop() }}
                </a>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (closed) {
    <div class="task-comments__closed">
      <p class="task-comments__closed-message">
        {{ closedMessage }} {{ closedAt | date: "dd/MM/yyyy" }} às {{ closedAt | date: "HH:mm" }}
      </p>
      <div class="task-comments__closed-badge"><i class="pi pi-check-circle"></i> {{ closedBadge }}</div>
    </div>
  } @else {
    <div class="task-comments__input-area">
      <div class="task-comments__input-wrapper">
        <textarea
          class="task-comments__textarea"
          [formControl]="messageControl"
          placeholder="Mensagem..."
          rows="2"></textarea>
        @if (attachedFiles.length) {
          <div class="task-comments__attached-files">
            <strong>Arquivos anexados:</strong>
            @for (file of attachedFiles; track $index) {
              <span class="task-comments__file-tag">
                {{ file.name }}
                <button type="button" class="task-comments__file-remove" (click)="removeFile($index)">x</button>
              </span>
            }
          </div>
        }
      </div>
      <div class="task-comments__actions">
        <input #fileInput type="file" multiple hidden (change)="onFileSelect($event)" />
        <app-button
          styleType="primary"
          icon="pi pi-paperclip"
          [disabled]="submitting"
          (btnClick)="fileInput.click()">
          Anexar Arquivos
        </app-button>
        <app-button
          styleType="secondary"
          icon="pi pi-comment"
          [loading]="submitting"
          [disabled]="submitting"
          (btnClick)="submitComment()">
          Comentar
        </app-button>
      </div>
    </div>
  }
</div>
